module.exports = __webpack_public_path__ + "img/home_top5.62a5748a.png";